import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class PlaceWiseHotelService {


  static getplacewiseHotel(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getplacewiseHotel}?id=${item?.id}`
      }
      else
      if(item?.range){
        api= `${API_BASE_URL}${API_PATHS.getplacewiseHotel}?range=${item?.range}`
     } else{
      api = `${API_BASE_URL}${API_PATHS.getplacewiseHotel}?limit=${item?.limit}&page=${item?.page}`;
      }
      return axiosInstance
          .get(api)
          
  }


  
static addplacewiseHotel(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addplacewiseHotel}`;
    return axiosInstance
        .post(api,item)
        
}

static editplacewiseHotel(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editplacewiseHotel}`;
    return axiosInstance
        .put(api,item)
        
}

static deleteplacewiseHotel(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deleteplacewiseHotel}?id=${item?.id}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default PlaceWiseHotelService;